export default "__VITE_ASSET__Dzb10Zkw__"